import React from 'react';
import { GridColDef, GridRowId, GridValidRowModel } from '@mui/x-data-grid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import ReactSwitch from 'react-switch';

interface VisibilityConditionSwitcherColumnProps {
    setRows: (newRows: (oldRows: any[]) => any[]) => void;
    gridApiRef: React.MutableRefObject<GridApiCommunity>;
    getRowId(row: GridValidRowModel): any;
    customCellClasses?: string;
}

const VisibilityConditionSwitcherColumn = (
    props: VisibilityConditionSwitcherColumnProps
): GridColDef => {
    const handleChange = (gridId: GridRowId, isEnabled: boolean) => {
        const latestStateMap = props.gridApiRef.current.getRowModels();
        const latestStateArray = Array.from(latestStateMap.values());

        const updatedStateArray = latestStateArray.map((row) => {
            const rowId = props.getRowId(row);
            if (rowId === gridId) {
                return {
                    ...row,
                    isVisibilityConditionEnabled: isEnabled,
                    visibilityConditionVariable: '',
                    visibilityConditionValues: [],
                };
            }
            return row;
        });

        props.setRows(() => updatedStateArray);
    };

    let cellClasses = 'switcher-cell';

    if (props.customCellClasses) {
        cellClasses = `${cellClasses} ${props.customCellClasses}`;
    }

    return {
        field: 'isVisibilityConditionEnabled',
        type: 'actions',
        headerName: 'Columns Visibility Condition',
        minWidth: 110,
        maxWidth: 110,
        headerAlign: 'left',
        cellClassName: cellClasses,
        getActions: (value: any) => {
            const id = value.id as number;
            const row = value.row as any;

            return [
                <ReactSwitch
                    offColor="#d92550"
                    checked={row?.isVisibilityConditionEnabled ?? false}
                    onChange={(event) => {
                        handleChange(id, event);
                    }}
                    height={22}
                />,
            ];
        },
    };
};

export default VisibilityConditionSwitcherColumn;
